<template>
  <section class="avatars-group pa-0 stacked">
    <div
      v-for="avatar in avatarsStackedLimited"
      :key="`avatar-id-${avatar.id}`"
      class="avatars-group__item"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <profile-avatar :avatar="avatar" :activator="on">
            <profile-presence
              v-if="presence"
              :presence="avatar.presence"
            ></profile-presence>
          </profile-avatar>
        </template>

        <profile-tooltip
          :avatar="avatar"
          :presence="presence"
        ></profile-tooltip>
      </v-tooltip>
    </div>
    <div class="avatars-group__item more">
      <v-avatar color="grey" size="40px">
        <v-menu
          v-model="stackedMenu"
          left
          :max-height="menuMaxHeight"
          nudge-bottom="8"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon :color="$vuetify.theme.dark ? 'grey darken-2' : 'white'"
                >mdi-dots-horizontal</v-icon
              >
            </v-btn>
          </template>
          <v-list dense two-line>
            <v-list-item
              v-for="avatar in avatarsSorted"
              :key="`avatar-menu-id-${avatar.id}`"
              avatar
            >
              <v-list-item-avatar>
                <profile-avatar
                  :avatar="avatar"
                  custom-class="bordered small"
                  size="32px"
                >
                  <profile-presence
                    v-if="presence"
                    :presence="avatar.presence"
                  ></profile-presence>
                </profile-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ avatar.alt }}</v-list-item-title>
                <v-list-item-subtitle>{{ avatar.role }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-avatar>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex';
import ProfileAvatar from '@/components/Admin/Header/TeamPresence/ProfileAvatar';
import ProfilePresence from '@/components/Admin/Header/TeamPresence/ProfilePresence';
import ProfileTooltip from '@/components/Admin/Header/TeamPresence/ProfileTooltip';
export default {
  components: {
    ProfileAvatar,
    ProfilePresence,
    ProfileTooltip
  },
  data() {
    return {
      mediaId: null,
      darkMode: false,
      menuMaxHeight: `${60 * 5 + 4}px`,
      presence: false,
      stackedLimit: 4,
      stackedMenu: false
    };
  },

  computed: {
    ...mapState({
      onlineManagers: (state) => state.onlineManagers
    }),
    avatars() {
      let managers = [];
      for (let id in this.onlineManagers) {
        //console.log('TEST', manager);
        managers.push({
          alt:
            this.onlineManagers[id].firstName +
            ' ' +
            this.onlineManagers[id].lastName,
          id: id,
          presence: 'Holiday',
          role: 'Managing: ' + this.onlineManagers[id].eventId,
          src: ''
        });
      }
      return managers;
    },
    /* eslint-disable */
    avatarsSorted() {
      return this.avatars && this.avatars.length > 0
        ? this.avatars.sort((a, b) => a.alt.localeCompare(b.alt))
        : null;
    },
    /* eslint-enable */
    avatarsStackedLimited() {
      return this.avatarsSorted && this.avatarsSorted.length > 0
        ? this.avatarsSorted.slice(0, this.stackedLimit)
        : null;
    }
  },

  created() {
    this.mediaId = window
      .matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', (e) => e.matches && this.DarkModeToggle());
    window
      .matchMedia('(prefers-color-scheme: light)')
      .addEventListener('change', (e) => e.matches && this.DarkModeToggle());
  },

  beforeDestroy() {
    window
      .matchMedia('(prefers-color-scheme: dark)')
      .removeEventListener('change', this.mediaId);
    window
      .matchMedia('(prefers-color-scheme: light)')
      .removeEventListener('change', this.mediaId);
  },

  methods: {
    DarkModeToggle() {
      this.darkMode = !this.darkMode;
    },
    GetColour(name) {
      var hash = 0;
      if (name.length === 0) return hash;
      for (var i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
      }
      var color = '#';
      for (i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 255;
        color += ('00' + value.toString(16)).substr(-2);
      }
      return color;
    }
  }
};
</script>
<style lang="scss">
$avatar-size: 20px;
$base-unit: 8px;
$border-width: $base-unit / 4;

.avatars-group {
  &.grid {
    display: grid;
    grid-gap: 16px;
    grid-template-columns: repeat(auto-fit, minmax(56px, 1fr));
  }
  &.stacked {
    display: flex;
    flex-direction: row;
    direction: ltr;
    max-width: 100%;
    overflow: hidden;
    overflow-x: hidden;
    white-space: nowrap;
    & > * {
      margin-right: -16px;
    }
    & > *:last-of-type {
      padding-right: 32px;
    }
  }
  .v-avatar {
    box-shadow: 0px 0px 0px 2px #fff inset;
    img {
      padding: 2px;
    }
    span {
      align-items: center;
      display: flex;
      font-size: 110%;
      font-weight: 700;
      height: 100%;
      justify-content: center;
      letter-spacing: 0.1rem;
      text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.56);
      width: inherit;
    }
  }
}
.avatars-group__item {
  cursor: default;
  transition: all 0.1s ease-out;
  &.more {
    align-items: center;
    display: flex;
    &:hover {
      transform: none;
    }
  }
  &:hover {
    /*transform: translateY(-1px);*/
    z-index: 1;
  }
}
.v-avatar {
  &.bordered {
    box-shadow: 0px 0px 0px 2px #fff inset;
    img {
      padding: 2px;
    }
    &.small {
      box-shadow: 0px 0px 0px 1px #fff inset;
      img {
        padding: 1px;
      }
      .presence {
        box-shadow: 0px 0px 0px 1px #fff inset;
        display: block;
        height: 16px;
        position: absolute;
        width: 16px;
      }
    }
  }
}
.presence {
  box-shadow: 0px 0px 0px 1px #fff inset;
  border-radius: 50%;
  bottom: 0px;
  display: block;
  height: 16px;
  position: absolute;
  width: 16px;
}
</style>
